import BasicModal from 'components/shared/BasicModal';
import UserPasswordForm from './UserPasswordForm';
import { Typography } from '@mui/material';
import { useState } from 'react';

const NewPasswordModal = () => {
  const [open, setOpen] = useState<boolean>(false);
  const handleOpen = () => setOpen(true);
  const handleClose = (): void => setOpen(false);

  return (
    <>
      <Typography
        color="textPrimary"
        onClick={handleOpen}
        sx={(theme) => ({
          fontSize: '0.875rem',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          marginLeft: 'auto',
          // transition: 'all 0.3s ease',
          cursor: 'pointer',
          '&:hover': {
            color: theme.palette.primary.main,
          },
        })}
      >
        ¿Ha olvidado su contraseña?
      </Typography>
      {open && (
        <BasicModal
          open={open}
          handleClose={handleClose}
        >
          <UserPasswordForm handleClose={handleClose} />
        </BasicModal>
      )}
    </>
  );
};

export default NewPasswordModal;
